<ngx-spinner type="ball-scale-multiple" size="medium" [name]="blockLoader"></ngx-spinner>

<!-- <div *ngIf="isHierarchyValueSelected(parentName, innerIndex, false) && canEditHierarchy" class="inner-containers">
	<p class="hierarchy-header headers">
		{{ getPlaceholderForHierarchy(selectedTemplate.hierarchies[innerIndex + 1]) }}
	</p>

	<ng-container *ngIf="selectedTemplate.hierarchies[innerIndex + 1]">
		<div class="levelSelection" *ngFor="let levelSelection of selectedTemplate.hierarchies[innerIndex + 1].values; let j = index">
			<div class="HierarchyValue" *ngIf="isHierarchyValueSelected(levelSelection, innerIndex + 1, true); else notSelected">
				<mat-checkbox (change)="hierarchyValueSelection($event, levelSelection, innerIndex + 1)" [checked]="isHierarchyValueSelected(levelSelection, innerIndex + 1, true)" class="selected-checkbox">
					{{ levelSelection }}
				</mat-checkbox>

				<div class="totalHierarchies" *ngIf="(innerIndex + 2) < totalHierarchies">
					<app-hierarchy-checkboxes [parentName]="levelSelection" [selectedTemplate]="selectedTemplate" [globalIndex]="globalIndex" [organisationHierarchy]="organisationHierarchy" [currentHierarchies]="currentHierarchies" [innerIndex]="innerIndex + 1" [parents]="getUpdatedParents(levelSelection)" [totalHierarchies]="totalHierarchies" [canEditHierarchy]="canEditHierarchy" (currentHierarchiesUpdateEvent)="updateCurrentHierarchies($event)"></app-hierarchy-checkboxes>
				</div>
			</div>

			<ng-template #notSelected>
				<mat-checkbox (change)="hierarchyValueSelection($event, levelSelection, innerIndex + 1)">
					{{ levelSelection }}
				</mat-checkbox>
			</ng-template>
		</div>
	</ng-container>
</div> -->

<div class="inner-containers" [ngClass]="{'canEditHierarchy': canEditHierarchy, 'cannotEditHierarchy': !canEditHierarchy}">
	<!-- <p class="hierarchy-header headers">
		{{ getPlaceholderForHierarchy(selectedTemplate.hierarchies[innerIndex + 1]) }}
	</p> -->
	<!-- <div class="levelSelection" > -->
		<div class="HierarchyValue" style="" *ngFor="let levelSelection of getLevelValues(innerIndex + 1); let j = index">
			<div [ngClass]="{'wrap': wrapContent}" class="flx	head" style="position: relative;">
				<div *ngIf="canEditHierarchy" class="delete plusBtn" (click)="deleteLevel(innerIndex + 1, levelSelection.orgIndex, levelSelection.value)">
					<img src="../../../../../assets/minus.png" alt="">
				</div>
				<span>{{ levelSelection.displayValue }}</span>

				<div class="icons">
					<div class="userIcon" (mouseenter)="showManagersList(levelSelection, true)"
					(mouseleave)="showManagersList(levelSelection, false)" (click)="viewLevelDetails(selectedTemplate.hierarchy[innerIndex + 1].name, levelSelection, levelSelection.orgIndex)">
						<mat-icon class="level-details-btns">group</mat-icon>
					</div>
					<div (click)="changeInputState('show', innerIndex, levelSelection.orgIndex)" class="plusBtn plus" *ngIf="(innerIndex + 2) < totalHierarchies && canEditHierarchy">
						<img src="../../../../../assets/images/plus.svg" alt="">
					</div>

				</div>

				<div class="managersList" *ngIf="levelSelection.showManagersList">
					<ul *ngIf="levelSelection?.managerNames?.length; else noMgrsAtLevel">
						<li *ngFor="let manager of levelSelection.managerNames">
							{{ manager.name }}
						</li>
					</ul>

					<ng-template #noMgrsAtLevel>
						<ul>
							<li>No Managers at this level</li>
						</ul>
					</ng-template>
				</div>

				<div class="inputBox hidden" [attr.id]="'newLevel-' + innerIndex + 'inner' + levelSelection.orgIndex + 'global' + globalIndex + 'local' + localIndex">
					<input type="text" placeholder="Level Name" [attr.id]="'newLevelName-' + innerIndex + 'inner' + levelSelection.orgIndex + 'global' + globalIndex + 'local' + localIndex">
					<div class="btns">
						<button style="width: 107px; font-size: 10px; padding: 5px 3px;" mat-button (click)="changeInputState('hide', innerIndex, levelSelection.orgIndex)">Cancel</button>
						<button style=" width: 107px;font-size: 10px;
						padding: 5px 3px;" mat-button [disabled]="!isLevelNameAdded(innerIndex, levelSelection.orgIndex)" (click)="addHierarchyLevel(levelSelection.value, innerIndex, levelSelection.orgIndex)">Add Level</button>
					</div>
				</div>
			</div>

			<div class="totalHierarchies" *ngIf="(innerIndex + 2) < totalHierarchies">
				<app-hierarchy-checkboxes [parentName]="levelSelection.value" [selectedTemplate]="selectedTemplate" [globalIndex]="globalIndex" [organisationHierarchy]="organisationHierarchy" [currentHierarchies]="currentHierarchies" [innerIndex]="innerIndex + 1" [parents]="getUpdatedParents(levelSelection.value)" [totalHierarchies]="totalHierarchies" [canEditHierarchy]="canEditHierarchy" [organisationId]="organisationId" [localIndex]="levelSelection.orgIndex" [orgCode]="orgCode" (currentHierarchiesUpdateEvent)="updateCurrentHierarchies($event)" [rolesData]="rolesData" [accordionIndex]="accordionIndex" (accordionUpdateEvent)="updateActiveAccordion($event)"></app-hierarchy-checkboxes>
			</div>
		</div>
	<!-- </div> -->

	<!-- <div class="levelSelection" *ngFor="let levelSelection of selectedTemplate.hierarchy[innerIndex + 1].values; let j = index">
		<div class="HierarchyValue">
			<mat-checkbox (change)="hierarchyValueSelection($event, levelSelection, innerIndex + 1)" [checked]="isHierarchyValueSelected(levelSelection, innerIndex + 1, true)" class="selected-checkbox" disabled="true">

				<div class="flx">
					<div class="flx2">
						<span>{{ levelSelection.value }}</span>

						<button mat-icon-button color="primary"
							(click)="viewLevelDetails(selectedTemplate.hierarchy[innerIndex + 1].name, levelSelection.value)">
							<mat-icon class="level-details-btns">group</mat-icon>
						</button>
						<div (click)="changeInputState('show', i)" class="plusBtn">
							<img src="../../../../../assets/images/plus.svg" alt="">
						</div>

						<div class="inputBox hidden" [attr.id]="'newLevel-' + innerIndex + i">
							<input type="text" placeholder="Level Name" [attr.id]="'newLevelName-' + innerIndex + i">
							<div class="btns">
								<button style="padding: 5px 10px; width: 107px;" mat-button (click)="changeInputState('hide', i)">Cancel</button>
								<button style="width: 107px;  padding: 5px 10px;" mat-button [disabled]="!isLevelNameAdded(i)" (click)="addHierarchyLevel(hierarchyOption.value, i)">Add Level</button>
							</div>
						</div>
					</div>

				</div>

			</mat-checkbox>

			<button mat-icon-button color="primary" (click)="addUser(selectedTemplate.hierarchies[innerIndex + 1].name)">
				<mat-icon class="level-details-btns">person_add</mat-icon>
			</button>

			<div class="totalHierarchies" *ngIf="(innerIndex + 2) < totalHierarchies">
				<app-hierarchy-checkboxes [parentName]="levelSelection.value" [selectedTemplate]="selectedTemplate" [globalIndex]="globalIndex" [organisationHierarchy]="organisationHierarchy" [currentHierarchies]="currentHierarchies" [innerIndex]="innerIndex + 1" [parents]="getUpdatedParents(levelSelection.value)" [totalHierarchies]="totalHierarchies" [canEditHierarchy]="false" [organisationId]="organisationId" (currentHierarchiesUpdateEvent)="updateCurrentHierarchies($event)"></app-hierarchy-checkboxes>
			</div>
		</div>
	</div> -->
</div>
